'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { Modal } from '@/app/components/Modal'
import { QRCode } from '@/app/components/QRCode'
import { useDownloadModal } from '@/app/providers/DownloadModalProvider'
import { getLocaleFromPathname } from '@/lib/i18n'
import DecorDownloadBottom from '@/public/images/decorDownloadBottom.svg'
import DecorDownloadTop from '@/public/images/decorDownloadTop.svg'

export function DownloadModal() {
  const { isOpen, closeModal } = useDownloadModal()
  const [downloaderUrl, setDownloaderUrl] = useState('')
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const locale = getLocaleFromPathname(pathname)
      const baseUrl = window.location.origin
      const path = locale === 'es' ? '/es/downloader' : '/downloader'
      setDownloaderUrl(`${baseUrl}${path}`)
    }
  }, [pathname])

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      variant="centered"
      showBackdrop={true}
      showCloseIcon
      className="w-full max-w-[740px]"
    >
      <div className="flex gap-5xl">
        <div className="flex flex-col gap-2xl p-5xl m-auto">
          <p className="size-heading-lg font-black">
            <mark>Download</mark>
            <br />
            the free app
          </p>
          <p className="size-body-lg">Scan the QR code with your smartphone to get Kite.</p>
        </div>
        <div className="p-5xl relative">
          {downloaderUrl && (
            <QRCode
              url={downloaderUrl}
              ariaLabel="Download Kite App"
              className="border-0 p-0 overflow-hidden"
              margin={25}
              size={230}
            />
          )}
          <DecorDownloadTop width={65} height={62} className="absolute top-[16px] left-[8px]" />
          <DecorDownloadBottom
            width={53}
            height={51}
            className="absolute bottom-[16px] right-[8px]"
          />
        </div>
      </div>
    </Modal>
  )
}
